export default __webpack_public_path__ + "static/media/admin-category-active.d0c81f46.svg";